module.exports = __webpack_public_path__ + "img/奖章3级@2x.6dfa78e6.png";